import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandler } from "@insite/client-framework/HandlerCreator";
import {
    Session,
} from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { userLoggedIn } from "@WhiteCap/Common/Utillities/CustomTracking";

export interface SignInParameter {
    userName: string;
    password: string;
    rememberMe: boolean;
    keepMeSignedIn?: boolean;
    returnUrl?: string | undefined;
    skipRedirect?: boolean;
    onError?: (error: string, statusCode?: number) => void;
}

export interface SignInResult {
    readonly access_token: string;
    readonly refresh_token: string;
    readonly expires_in: number;
    readonly error_description: string;
}


type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

export const SendDataLayer: HandlerType = props => {
    const session = getSession(props.getState());

    let accountType = "";
    if (session.properties?.isBusinessAccount) {
        accountType = session.properties?.isBusinessAccount.toLowerCase() === "true" ? "Company" : "Personal";
    }

    if (props?.authenticatedSession?.isAuthenticated) {
        userLoggedIn({
            event: "user_logged_in",
            account_type: accountType,
            user_id: props.authenticatedSession?.userName ?? props.parameter.userName
        })
    }
};

addToChainAfter(chain, DispatchCompleteSignIn, SendDataLayer);